import {DirectiveOptions} from 'vue';
import mutations from '@/mutations';

const ActionHint: DirectiveOptions = {
	bind(el, binding, vnode) {
		el.addEventListener('mouseenter', () => {
			vnode.context.$store.commit(mutations.updateActionHint, binding.value);
		});

		el.addEventListener('mouseleave', () => {
			vnode.context.$store.commit(mutations.updateActionHint, '');
		});
	}
};

export default ActionHint;